import { saveAs } from 'file-saver';

export const downloadPdf = (shipmentStore, shipmentId, format) => {
    shipmentStore.getLabel(shipmentId, format, (response) => {
      if (response.status === 200) {
        let contentType = 'text/plain';
        let fileName = `order-${shipmentId}-label.txt`;
        let blob;
        const data = response.data.label;
        if (format === 'PDF') {
          contentType = 'application/pdf';
          fileName = `order-${shipmentId}-label.pdf`;
          blob = b64toBlob(data, contentType);
        } else if (format === 'PNG') {
          contentType = 'image/png';
          fileName = `order-${shipmentId}-label.png`;
          blob = b64toBlob(data, contentType);
        } else {
          blob = new Blob([data], {type: "text/plain;charset=utf-8"});
        }

        saveAs(blob, fileName);
      }
    })
};

export const downloadFile = (fileName, format, data) => {
  let blob = getBlob(fileName, format, data);
  saveAs(blob, fileName);
};

export const getBlob = (fileName, format, data) => {
  let contentType = 'text/plain';
  let blob;
  if (format === 'PDF') {
    contentType = 'application/pdf';
    blob = b64toBlob(data, contentType);
  } else if (format === 'PNG') {
    contentType = 'image/png';
    blob = b64toBlob(data, contentType);
  } else if (format === 'JPEG') {
    contentType = 'image/jpeg';
    blob = b64toBlob(data, contentType);
  } else {
    blob = new Blob([data], {type: "text/plain;charset=utf-8"});
  }
  return blob;
};

const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
};